"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MatchLineupFieldHalfPitchProps {
  children: React.ReactNode;
}

/**
 * Vertical half-pitch with field markings (taller aspect ratio)
 * Used for mobile lineup display showing one team at a time
 */
export const MatchLineupFieldHalfPitch: React.FC<MatchLineupFieldHalfPitchProps> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="absolute inset-0 w-full h-full" viewBox="0 0 68 70" preserveAspectRatio="none"><rect x="4" y="4" width="60" height="62" fill="none" stroke="white" strokeWidth="0.5" /><line x1="4" y1="66" x2="64" y2="66" stroke="white" strokeWidth="0.5" /><path d="M 25 66 A 9.15 9.15 0 0 1 43 66" fill="none" stroke="white" strokeWidth="0.5" /><rect x="13.5" y="4" width="41" height="16.5" fill="none" stroke="white" strokeWidth="0.5" /><rect x="24.5" y="4" width="19" height="5.5" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 25.5 20.5 A 9.15 9.15 0 0 0 42.5 20.5" fill="none" stroke="white" strokeWidth="0.5" /><circle cx="34" cy="16" r="0.5" fill="white" /><path d="M 5.5 4 A 1.5 1.5 0 0 0 4 5.5" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 62.5 4 A 1.5 1.5 0 0 1 64 5.5" fill="none" stroke="white" strokeWidth="0.5" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="relative w-full aspect-68/70 bg-green-600 rounded-lg overflow-hidden">{t1}<div className="absolute inset-0">{children}</div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};